import React, { useContext } from 'react'
import SettingsButtons from './SettingsButtons'
import ManualInputs from './Inputs'
import Slider from '../components/slider/Slider'
import Bet from './Bet'
import { Manual_configs_props } from './interface'

export default function ManualConfigs({
  autoConfig,
  autoRoll,
  winchance,
  multiplier,
  handleRollUnder,
  handleStake,
  handleAutoConfigs,
  handleManual,
  handleAbove,
  handleChance,
  handleMultiplier,
  handleSliderValue,
  focusedHandler,
  socketValue,
  focused,
  startAuto,
  audio,
  setAutoRoll,
  active,
  resetAuto,
  prec,
}: Manual_configs_props) {
  return (
    <>
      {!autoConfig && (
        <SettingsButtons
          autoRoll={autoRoll}
          handleAbove={handleAbove}
          handleAutoConfigs={handleAutoConfigs}
          handleManual={handleManual}
          audio={audio}
          setAutoRoll={setAutoRoll}
          resetAuto={resetAuto}
        />
      )}
      <ManualInputs
        winchance={winchance}
        multiplier={multiplier}
        handleChance={handleChance}
        handleMultiplier={handleMultiplier}
      />
      <Slider
        title='config'
        socketValue={socketValue}
        handleSliderValue={handleSliderValue}
        focusedHandler={focusedHandler}
        focused={focused}
        startAuto={startAuto}
        active={active}
      />
      <Bet
        autoConfig={autoConfig}
        handleStake={handleStake}
        handleRollUnder={handleRollUnder}
        startAuto={startAuto}
        audio={audio}
        prec={prec}
      />
    </>
  )
}
